import {
  PawPrint,
  Shield,
  CloudRain,
  HelpCircle,
  PersonStanding,
  Car,
} from 'lucide-react';

interface EventIconProps {
  eventType: string;
  className?: string;
}

export function EventIcon({
  eventType,
  className = 'h-4 w-4',
}: EventIconProps) {
  const normalizedType = eventType.toLowerCase().replace(/[_\s]/g, '');

  switch (normalizedType) {
    case 'pet':
      return <PawPrint className={className} />;
    case 'person':
      return <PersonStanding className={className} />;
    case 'vehicle':
      return <Car className={className} />;
    case 'policereport':
      return <Shield className={className} />;
    case 'weatherreport':
      return <CloudRain className={className} />;
    default:
      return <HelpCircle className={className} />;
  }
}
